module.exports = __webpack_public_path__ + "media/images/bg/blank-green-34104d42b4577121a71290c47c72fdea.svg";